/** The value actions of the Knowledge gaps page — one family, one links module (the detail-page
 *  value actions rule). Every href comes from `gridLinks`; `knowledgeGapLinks.test.ts` proves each
 *  one lands on a real route. */
import type { KnowledgeGapKindKey, KnowledgeGapRow } from '@/api/knowledgeGaps';
import type { GridLink } from '@/components/ValueActions/identity';
import { act, type ValueAction } from '@/components/ValueActions/ValueActions';
import { knowledgeGapsHref, plainHref } from '@/utils/gridLinks';

/** A tenant on the page: its own gaps. */
export const tenantGrid = (tenantId: number): GridLink => ({
  href: knowledgeGapsHref({ tenant: tenantId, group: 'tenant' }),
  label: 'Knowledge gaps of this operator',
});

export function kindActions(kind: KnowledgeGapKindKey): ValueAction[] {
  return [act.filter(knowledgeGapsHref({ kind }), 'Only this kind')];
}

/** A subject clients' AI asked for (never a withheld placeholder): the gaps naming it, and a copy. */
export function subjectActions(row: KnowledgeGapRow): ValueAction[] {
  if (row.withheld) return [];
  return [
    act.filter(knowledgeGapsHref({ search: row.subject, group: 'tenant' }), 'Every tenant that asked it'),
    act.copy(row.subject, 'Copy'),
  ];
}

/** A word one tenant's AI looked up and found nothing for: that tenant's AI vocabulary tab, with a
 *  new entry for the word open (`?define=`). Null for any other row. */
export function defineHref(row: KnowledgeGapRow): string | null {
  if (row.kind !== 'lookup_miss' || row.withheld || row.tenant_id == null || !row.tenant) return null;
  return plainHref(`/tour-operators/${row.tenant_id}/ai-vocabulary`, { define: row.subject });
}
